/* eslint-disable radix */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React from 'react';
import { useDispatch } from 'react-redux';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { addModuloID } from '~/store/modules/Menu/actions';
import Lista from './Lista';
import { Container } from './styles';

function Card({
  modulos,
  loading,
  selected,
  setSelected,
  handeGetMenusData,
  setLoading,
}) {
  const dispatch = useDispatch();
  return (
    <Container>
      <Form style={{ width: '100%' }} onSubmit={handeGetMenusData}>
        <FormGroup>
          <Label>Selecione o módulo para visualizar os menus</Label>
          <Input
            placeholder="Selecione..."
            type="select"
            // eslint-disable-next-line radix
            onChange={(e) => {
              setSelected(false);
              dispatch(addModuloID(parseInt(e.target.value)));
              handeGetMenusData(e);
            }}
            defaultValue=""
            disabled={loading}
          >
            <option value="" disabled>
              Selecione...
            </option>
            {modulos.map((modulo, index) => (
              <option key={index} value={modulo.id}>
                {modulo.nome}
              </option>
            ))}
          </Input>
        </FormGroup>
      </Form>
      {selected ? <Lista setLoading={setLoading} loading={loading} /> : ''}
    </Container>
  );
}

export default Card;
